import { render, staticRenderFns } from "./TreatmentHistory.vue?vue&type=template&id=607bc51e"
import script from "./TreatmentHistory.vue?vue&type=script&lang=js"
export * from "./TreatmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports